// libs
import isBefore from 'date-fns/isBefore';

import { DateFormat, formatDate } from '@lyearn/core/utils/date/formatDate';
import { TFunction } from '@lyearn/i18n';

// types
import {
  Content,
  ContentOverdueDueEnum,
  ContentPerformanceStatusEnum,
  OverdueTranslationKeys,
} from '../types';
// utils
import getStatus from '../useStatus/getStatus';

const DEFAULTS = {
  DUE: 'ContentCards.Due',
  OVERDUE: 'ContentCards.Overdue',
  COMPLETED: 'ContentCards.Completed',
  DUE_SHORT: 'ContentCards.DueShort',
};

export const getOverdue = (
  t: TFunction,
  content: Content,
  translationKeys?: OverdueTranslationKeys,
) => {
  const dueDateISOString = content.performance?.enrolmentInfo?.dueDate;

  const status = getStatus(content);
  const i18n = { ...DEFAULTS, ...translationKeys };

  if (status === ContentPerformanceStatusEnum.Completed) {
    return {
      status: ContentOverdueDueEnum.Completed,
      label: t(i18n[ContentOverdueDueEnum.Completed]),
      shortenedLabel: t(i18n[ContentOverdueDueEnum.Completed]),
    };
  }

  if (!dueDateISOString) {
    return null;
  }

  const dueDate = new Date(dueDateISOString);
  const isOverdue = isBefore(dueDate, Date.now());

  if (isOverdue) {
    return {
      status: ContentOverdueDueEnum.Overdue,
      label: t(i18n[ContentOverdueDueEnum.Overdue]),
      shortenedLabel: t(i18n[ContentOverdueDueEnum.Overdue]),
    };
  }

  return {
    status: ContentOverdueDueEnum.Due,
    label: t(i18n[ContentOverdueDueEnum.Due], {
      date: formatDate(dueDate, DateFormat.Date, { showFullMonth: false }),
    }),
    shortenedLabel: t(i18n[ContentOverdueDueEnum.DueShort], {
      date: formatDate(dueDate, DateFormat.Date),
    }),
  };
};
